module.exports = __webpack_public_path__ + "static/img/yunxianchang.38befa92.jpg";